import { useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Intro from "@/components/service/components/intro/Intro";
import WebBanner from "@/components/service/components/banner/WebBanner";
import VisualBenefits from "@/components/service/components/visual-benefits/VisualBenefits";
import TextBubbles from "@/components/service/web-design/text-bubbles/TextBubbles";
import WebDesignIcons from "@/components/service/web-design/icons/Icons";
import Inclusives from "@/components/service/components/inclusives/Inclusives";
import Exclusives from "@/components/service/components/exclusives/Exclusives";
import Button from "@/components/common/buttons/Button";
import Faq from "@/components/contact/faq/Faq";
import PageSEO from "@/components/common/PageSEO";
import Spacing from "@/components/common/Spacing";
import serversideTrackingData from "@/data/services/serverside-tracking/plans.json";
import faq from "@/data/services/serverside-tracking/faq.json";
import "./serverside-tracking.css";

const ServerSideTracking = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("page-serverside-tracking");
    return () => {
      document.body.classList.remove("page-serverside-tracking");
    };
  }, []);
  const SliderRef = useRef<HTMLDivElement>(null);

  const scrollToRef = () => {
    if (SliderRef.current) {
      SliderRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const plan = serversideTrackingData[0];

  return (
    <>
      <PageSEO section="services" keyName="serverside-tracking" />
      <Intro data={plan} />

      <Container style={{ height: "100%" }}>
        <WebBanner
          onClick={scrollToRef}
          img="/project-images/serverside-tracking.webp"
        />
      </Container>

      <TextBubbles info={plan} />

      <div ref={SliderRef}>
        <VisualBenefits icon="bullet" data={plan} />
      </div>

      <Container>
        <Spacing size={4} />
        <WebDesignIcons info={plan} />
        <Spacing size={4} />

        {plan.inclusiveTitle && plan.inclusives && (
          <Inclusives
            data={{
              inclusiveTitle: plan.inclusiveTitle,
              inclusives: plan.inclusives,
            }}
          />
        )}
        <Spacing size={4} />
        {plan.exclusiveTitle && plan.exclusives && (
          <Exclusives
            data={{
              exclusiveTitle: plan.exclusiveTitle,
              exclusives: plan.exclusives,
            }}
          />
        )}
      </Container>

      <Container>
        <Spacing size={6} />
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <div
              style={{
                borderRadius: "22px",
                padding: "1px",
                background:
                  "linear-gradient(135deg, rgba(36,196,157,0.35), rgba(238,177,127,0.35))",
                marginBottom: "2rem",
              }}
            >
              <div
                className="serverside-pricing-card"
                style={{
                  background:
                    "linear-gradient(135deg, #050505 0%, #0c1104 100%)",
                  borderRadius: "20px",
                  padding: "clamp(1.5rem, 4vw, 3rem)",
                  position: "relative",
                  overflow: "visible",
                  minHeight: "auto",
                }}
              >
                {/* Glow effect is now handled entirely via CSS */}
                <div className="serverside-glow-effect" />

                <h2
                  style={{
                    fontSize: "clamp(1.5rem, 5vw, 2.5rem)",
                    fontWeight: "bold",
                    color: "#fcfff9",
                    marginBottom: "1rem",
                    fontFamily:
                      "Space Grotesk, system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  ServerSide Tracking Enterprise
                </h2>

                <div
                  style={{
                    fontSize: "clamp(1.8rem, 6vw, 3rem)",
                    fontWeight: "bold",
                    color: "#a9f2d0",
                    marginBottom: "1rem",
                    position: "relative",
                    zIndex: 2,
                    lineHeight: "1.2",
                  }}
                >
                  €990 setup + €149/lună
                  <br />= economie €800 lunar*
                </div>

                <p
                  style={{
                    fontSize: "clamp(1rem, 3vw, 1.2rem)",
                    color: "#9aa19f",
                    marginBottom: "1rem",
                    lineHeight: "1.6",
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  Tracking enterprise fără compromisuri.
                  <br />
                  GA4 îți dă rapoarte cu delay, ad-blockerele îți blochează
                  datele, SKAN încurcă atribuirea. Noi rezolvăm tot.
                </p>

                <p
                  style={{
                    fontSize: "0.8rem",
                    color: "#9aa19f",
                    marginBottom: "2rem",
                    lineHeight: "1.4",
                    position: "relative",
                    zIndex: 2,
                    fontStyle: "italic",
                    opacity: 0.8,
                  }}
                >
                  *Estimare calculată pe buget de ~€2.000/lună. Reducerea e 100%
                  reală dacă știi ce faci în Ads.
                </p>

                <div className="serverside-button-container">
                  <Button
                    className="menu-button button-body serverside-demo-button"
                    text="Vreau acces demo"
                    onClick={() =>
                      window.open(
                        "https://wa.me/40745371620?text=Vreau demo serverside tracking",
                        "_blank",
                      )
                    }
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <Container>
        <Spacing size={6} />
        <Faq data={faq} />
        <Spacing size={6} />
      </Container>
    </>
  );
};

export default ServerSideTracking;
